import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    supplierDataChange_title: 'Изменение места расположения',
    supplierDataChange_subtitle: 'Реестр поставщиков',
    supplierDataChange_columnBin: 'БИН',
    supplierDataChange_columnName: 'Наименование организации',
    supplierDataChange_columnIin: 'ИИН руководителя',
    supplierDataChange_columnLocation: 'Место расположения',
    supplierDataChange_errorLoadTable: 'Ошибка загрузки списка поставщиков',
    supplierDataChange_designCapacity: 'Проектная мощность',
    supplierDataChange_legalAddress: 'Новый адрес',
    supplierDataChange_sign: 'Подписать',
    supplierDataChange_requiredField: 'Поле обязательно для заполнения',
    supplierDataChange_designCapacityInvalid: 'Введите число больше 0',
    supplierDataChange_notifySuccess: 'Уведомление успешно отправлено',
    supplierDataChange_notifyError: 'Не удалось подписать заявление',
    supplierDataChange_notificationsTitle: 'Уведомления и талоны по смене адреса поставщика',
    supplierDataChange_errorLoadNotifications: 'Ошибка загрузки уведомлений',
    supplierDataChange_columnDate: 'Дата',
    supplierDataChange_columnStatus: 'Статус',
    supplierDataChange_columnActions: 'Действия',
    supplierDataChange_revoke: 'Отозвать',
    supplierDataChange_changeAddress: 'Изменить адрес',
    supplierDataChange_annulTitle: 'Аннулирование уведомления',
    supplierDataChange_annulBody: 'Уведомление будет аннулировано',
    supplierDataChange_confirm: 'Подтвердить',
    supplierDataChange_cancel: 'Отмена',
    supplierDataChange_annulSuccess: 'Уведомление успешно аннулировано',
    supplierDataChange_annulError: 'Не удалось аннулировать уведомление',
    supplierDataChange_alreadyExistingNotification:
      'По данному поставщику уже существует активная заявка. Подача нового уведомления невозможна.'
  },
  kk: {
    supplierDataChange_title: 'Орналасқан жерін өзгерту',
    supplierDataChange_subtitle: 'Жеткізушілер тізімі',
    supplierDataChange_columnBin: 'БСН',
    supplierDataChange_columnName: 'Ұйымның атауы',
    supplierDataChange_columnIin: 'Басшының ЖСН',
    supplierDataChange_columnLocation: 'Орналасқан жері',
    supplierDataChange_errorLoadTable: 'Жеткізушілер тізімін жүктеу қатесі',
    supplierDataChange_designCapacity: 'Жобалық қуаты',
    supplierDataChange_legalAddress: 'Жаңа мекенжай',
    supplierDataChange_sign: 'Қол қою',
    supplierDataChange_requiredField: 'Бұл өрісті толтыру міндетті',
    supplierDataChange_designCapacityInvalid: '0-ден үлкен сан енгізіңіз',
    supplierDataChange_notifySuccess: 'Хабарлама сәтті жіберілді',
    supplierDataChange_notifyError: 'Өтінішке қол қою мүмкін болмады',
    supplierDataChange_notificationsTitle: 'Жеткізушінің мекенжайын өзгерту бойынша хабарламалар мен талондар',
    supplierDataChange_errorLoadNotifications: 'Хабарламаларды жүктеу қатесі',
    supplierDataChange_columnDate: 'Күні',
    supplierDataChange_columnStatus: 'Мәртебесі',
    supplierDataChange_columnActions: 'Әрекеттер',
    supplierDataChange_revoke: 'Кері қайтару',
    supplierDataChange_changeAddress: 'Мекенжайды өзгерту',
    supplierDataChange_annulTitle: 'Хабарламаны жою',
    supplierDataChange_annulBody: 'Хабарлама жойылады',
    supplierDataChange_confirm: 'Растау',
    supplierDataChange_cancel: 'Бас тарту',
    supplierDataChange_annulSuccess: 'Хабарлама сәтті жойылды',
    supplierDataChange_annulError: 'Хабарламаны жою мүмкін болмады',
    supplierDataChange_alreadyExistingNotification:
      'Осы жеткізуші бойынша белсенді өтініш бұрыннан бар. Жаңа хабарлама беру мүмкін емес.'
  }
});
